import { render, staticRenderFns } from "./BaseLoaderDots.vue?vue&type=template&id=8f1e544a&scoped=true"
import script from "./BaseLoaderDots.vue?vue&type=script&lang=js"
export * from "./BaseLoaderDots.vue?vue&type=script&lang=js"
import style0 from "./BaseLoaderDots.vue?vue&type=style&index=0&id=8f1e544a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1e544a",
  null
  
)

export default component.exports